import React from "react";
import "./styles.css/Footer.css";

export default function Footer() {
  return (
    <footer className="footer-section">
      <p>&copy; 2025 T S Styles Innovations (Pty) Ltd. All Rights Reserved.</p>
   
    </footer>
  );
}
